import Model from '../utils/Model'

class FileState {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'FileState'

export const WSC_TYPE = new FileState(0, '未送出', "Haven't Sent")
export const YSC_TYPE = new FileState(1, '已送出', 'Sent')
export const YJD_TYPE = new FileState(10, '已接单', 'Received')
export const YGD_TYPE = new FileState(11, '已归档', 'Filed')
export const YTS_TYPE = new FileState(12, '已退税', 'DrawBacked')
export const YQH_TYPE = new FileState(2, '已取回', 'Took Back')
export const YTH_TYPE = new FileState(3, '已退还', 'Returned')

export const FILE_STATES = [WSC_TYPE, YSC_TYPE, YJD_TYPE, YGD_TYPE, YTS_TYPE, YQH_TYPE, YTH_TYPE]

export const ALL_TYPE = new FileState(100, '全部', 'All')
export const NCD_TYPE = new FileState(-1, '未创建报关单', 'Not Created Declaration')

/**
 *  return "":没找到.
 */
export function getFileStateByCode(code) {
  return Model.getObjByCode(code, FILE_STATES)
}
